import axios from 'axios'

let newback = {}
const lprotocol = location.protocol
const host = location.hostname
const api = (host === 'localhost')
  ? process.env.VUE_APP_ROOT_TEST_API
  : `${lprotocol}//${host}/api/`

newback.baseURL = api
export const HTTP = axios.create(newback)

HTTP.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    localStorage.removeItem('so_token')
    if (host !== 'localhost') {
      document.location.replace('/login')
    }
  }
  return Promise.reject(error)
})

if (window.parent.localStorage.getItem('so_token') !== null) {
  HTTP.defaults.headers.common['Authorization'] = window.parent.localStorage.getItem('so_token')
} else {
  if (host !== 'localhost') {
    if (location.pathname !== '/login') {
      document.location.replace('/login')
    }
  } else {
    /* При отсутствии токена запрашиваем данные */
    /** логин */
    let username = window.prompt('Логин')
    /** пароль (можно не вводить для локальной авторизации) */
    let userpass = window.prompt('Пароль')
    const params = new URLSearchParams()
    params.append('login', username)
    params.append('pass', userpass)
    params.append('application', 'sakura')
    HTTP.post('/login', params)
    .then(response => {
      let login = response.data
      window.localStorage.setItem('so_token', login.token_type + ' ' + login.access_token)
      HTTP.defaults.headers.common['Authorization'] = login.token_type + ' ' + login.access_token
    })
    sessionStorage.setItem('so_pult', 'AG-1');
  }
}